import React from 'react';
import './style.css';

const CardList = () => {
  const jobs = [
    {
      companyLogo: 'https://i.pinimg.com/1200x/c7/6b/9b/c76b9b375977ec655f56ebb67e3a26cc.jpg',
      title: 'Cybersecurity',
      company: 'Dropbox',
      location: 'Warszawa',
      isCriptografia: true,
      tags: ['Sketch'],
      salary: '8.8 – 13.7k PLN',
      date: '2 days ago'
    },
    {
      companyLogo: 'https://i.pinimg.com/1200x/e2/ea/c8/e2eac8bc6181acc4c5b5a10f20bba961.jpg',
      title: 'Gestão de Projetos',
      company: 'Twitch',
      location: 'Wroclaw',
      isRemote: true,
      tags: [],
      salary: '8.2 – 13.5k PLN',
      date: '2 days ago'
    },
    {
      companyLogo: 'https://i.pinimg.com/1200x/df/ab/00/dfab009b4ca4d95f946c273f32f77df7.jpg',
      title: 'Observabilidade',
      company: 'Google',
      location: 'Warszawa',
      isRemote: true,
      tags: ['JavaScript'],
      salary: '7.5 – 12.5k PLN',
      date: '3 days ago'
    }
  ];

return (
    <div className="card-list">
        <h2 className="section-title">Áreas de atuação</h2>
        {jobs.map((job, index) => (
        <div className={`cardL ${index === 1 ? 'highlighted' : ''}`} key={index}>
            <div className="left-section">
            <img src={job.companyLogo} alt={`${job.company} logo`} className="logo" />
            <div className="info">
                <h3>{job.title}</h3>
                <div className="tags">
                {job.isRemote && <span className="tag remote">Remote</span>}
                {job.isCriptografia && <span className="tag criptografia">Criptografia</span>}
                {job.tags.map((tag, i) => (
                    <span className={`tag ${tag.toLowerCase()}`} key={i}>{tag}</span>
                ))}
                </div>
                <p className="company">{job.company} — {job.location}</p>
            </div>
            </div>
            <div className="right-section">
            <p className="salary">{job.salary}</p>
            <p className="date">{job.date}</p>
            </div>
        </div>
        ))}
    </div>
    );
};

export default CardList;
